import { ChecksList } from 'components/ChecksList';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { MainTitle } from 'components/MainTitle';
import { Layout } from 'features/Layouts/Layouts';
import { FC } from 'react';
import { useGetChecksQuery } from 'redux/Api/checksApi/checksApi';
import styles from './ChecksContent.module.scss';

export const ChecksContent: FC = () => {
  const { data, isLoading } = useGetChecksQuery();
  return (
    <Layout>
      <div className={styles.root}>
        <MainTitle title='Чеки' count={data?.count} />
        {isLoading ? <LoadingSkeleton /> : <ChecksList data={data?.items} />}
      </div>
    </Layout>
  );
};
